import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  baseUrl,
  timeList
} from "../comman/config";
import Select from "react-select";

import { DateSessionFilter } from "../components/Filter/DateSessionFilter";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../components/Loader";
import { ItemNameStacked } from '../components/ItemName';
import { menuAboveTable, withMenuOnTop } from "../comman/selectMenu";
// import * as XLSX from 'xlsx';


function ProductionPlanningList() {
  const today = new Date().toISOString().split("T")[0];
  const [mealList, setMealList] = useState([]);
  const [mealSummary, setMealSummary] = useState([]);
  const [mealDetail, setMealDetail] = useState([]);
  const [removeMealDetail, setRemoveMealDetail] = useState([]);
  // const [rmDetailForItem, setRMDetailForItem] = useState([]);
  // const [activeIndex, setActiveIndex] = useState(null);
  const [vesselList, setVesselList] = useState([]);
  // const [ingredientList, setIngredientList] = useState([]);
  const [date, setDate] = useState(today);
  const [session, setSession] = useState("");
  const role = localStorage.getItem('userRole');
  const [loading, setLoading] = useState(false)
  // const [formData, setFormData] = useState([]);
  // const [detail, setDetail] = useState([]);

  useEffect(() => {
    getVesselList();
    // getIngredientList();
  }, []);
  // useEffect(() => {
  //   // Create initial formData and validationErrors based on mealList length
  //   const initialFormData = Array.from({ length: batchSize }, (_, index) => ({
  //     batch: index + 1,
  //     planned_batch_raw_qty: "",
  //     vessel_id: "",
  //     start_time: "",
  //     end_time:"",
  //     requisition_no: "",
  //     remarks: "",
  //     ingredientDetail: []
  //   }));
  //   setFormData(initialFormData);
  // }, [batchSize]);

  useEffect(() => {
    if (mealList.length === 0 || vesselList.length === 0) return;

    const fetchDetail = async () => {
      setLoading(true);

      // Build one batch request: 3 queries per meal item (production_planning,
      // production_receipe_planning, raw_material) — all run in parallel server-side.
      const queries = mealList.flatMap(item => [
        {
          key: `pp_${item.menu_item_id}`,
          table: 'production_planning',
          condition: `menu_item_id='${item.menu_item_id}' AND date='${date}' AND session='${session.value}'`,
        },
        {
          key: `prp_${item.menu_item_id}`,
          table: 'production_receipe_planning',
          condition: `menu_item_id='${item.menu_item_id}' AND date='${date}' AND session='${session.value}'`,
        },
        {
          key: `rm_${item.menu_item_id}`,
          table: 'raw_material',
          condition: `date='${date}' AND session='${session.value}' AND menu_item_id='${item.menu_item_id}'`,
        },
      ]);

      const batchResponse = await axios.post(
        `${baseUrl}/comman/batch-list`,
        { queries },
        { headers: { 'Cache-Control': 'no-cache' } }
      );
      const batchData = batchResponse.data.data;

      const mealDetails = [];
      for (const item of mealList) {
        const ppRows = batchData[`pp_${item.menu_item_id}`] ?? [];
        const prpRows = batchData[`prp_${item.menu_item_id}`] ?? [];

        if (ppRows.length > 0) {
          const sortedData = ppRows.sort((a, b) => a.batch - b.batch);
          for (const value of sortedData) {
            const vesselItem = vesselList.find(v => v.id == value.vessel_id);
            const vesselObject = vesselItem
              ? { value: vesselItem.id, label: vesselItem.name }
              : { value: 210, label: 'No Vessel' };

            const timeslotItem = timeList.find(t => t.value == value.start_time);
            const timeslotObject = timeslotItem
              ? { value: timeslotItem.value, label: timeslotItem.label }
              : { value: '', label: '' };

            const endTimeItem = timeList.find(t => t.value == value.end_time);
            const endTimeSlotObject = endTimeItem
              ? { value: endTimeItem.value, label: endTimeItem.label }
              : { value: '', label: '' };

            const itemDisable = prpRows.some(r => r.batch == value.batch);
            mealDetails.push({
              batch: value.batch,
              menu_item_id: value.menu_item_id,
              item_name: item.item_name,
              eng_name: item.eng_name,
              planned_batch_raw_qty: value.planned_batch_raw_qty,
              vessel_id: vesselObject,
              start_time: timeslotObject,
              end_time: endTimeSlotObject,
              itemDisable: (role == 0 || role == 1) ? false : itemDisable,
              removeRow: itemDisable,
              remarks: value?.remarks ?? '',
            });
          }
        } else {
          const itemDisable = prpRows.some(r => r.batch == 1);
          mealDetails.push({
            batch: 1,
            menu_item_id: item.menu_item_id,
            item_name: item.item_name,
            eng_name: item.eng_name,
            planned_batch_raw_qty: 0,
            vessel_id: { label: 'No Vessel', value: 210 },
            start_time: '',
            end_time: '',
            itemDisable: (role == 0 || role == 1) ? false : itemDisable,
            removeRow: itemDisable,
            remarks: '',
          });
        }
      }

      setMealDetail(mealDetails);

      const dataArray = mealList.map(item => {
        const rmRows = batchData[`rm_${item.menu_item_id}`] ?? [];
        return {
          menu_item_id: item.menu_item_id,
          item_name: item.item_name,
          eng_name: item.eng_name,
          total_planned_raw_qty: rmRows[0]?.planned_rm_qty || 0,
          total_planned_batch_raw_qty: 0,
          pending_planned_qty: 0,
        };
      });

      setMealSummary(dataArray);
      updateSummedQuantities(mealDetails, dataArray);
      setLoading(false);
    };

    fetchDetail();
  }, [mealList, vesselList]);


  const getVesselList = async () => {
    const response = await axios.get(
      `${baseUrl}/comman/list?table=vessel_master&condition=status=1`,
      { headers: { 'Cache-Control': 'no-cache' } }
    );
    setVesselList(response.data.data);
  };

  // const getIngredientList = async () => {
  //   const response = await axios.get(`${baseUrl}/ingredients/list?limit=all`, { headers: { 'Cache-Control': 'no-cache' } });
  //   const list = response.data.data.filter((item) => item.status == 1);
  //   setIngredientList(list);
  // };

  const handelFilterChange = async (date, session) => {
    setDate(date);
    setSession(session);
    if (date && session) {
      const condition = ` m.session='${session.value}' AND m.date='${date}'`;
      const response = await axios.get(
        `${baseUrl}/meal_master/item_list?condition=${condition}`, { headers: { 'Cache-Control': 'no-cache' } }
      );
      setMealList(response.data.data);
    }
  };


  const handleSave = async (e) => {
    e.preventDefault();

    const newMessages = [];

    mealSummary.forEach((item, index) => {
        if (item.pending_planned_qty < 0) {
            newMessages.push(`${item.item_name} માટે નક્કી થયેલ જથ્થા કરતા પ્રોડક્શન જથ્થો "ઓછો" લીધેલ છે.`);
        } else if (item.pending_planned_qty > 0) {
            newMessages.push(`${item.item_name} માટે નક્કી થયેલ જથ્થા કરતા પ્રોડક્શન જથ્થો "વધારે" લીધેલ છે.`);
        }
    });
    const validateData = (data) => {
        const errors = [];
      
        data.forEach((item) => {
        //   if (item.planned_batch_raw_qty === "" || item.planned_batch_raw_qty == null) {
        //     errors.push({
        //       item_name: item.item_name,
        //       batch: item.batch,
        //       error: "Planned batch raw quantity is required."
        //     });
        //   }
      
        //   if (item.vessel_id.value === "" || item.vessel_id.value == null) {
        //     errors.push({
        //       item_name: item.item_name,
        //       batch: item.batch,
        //       error: "Vessel ID is required."
        //     });
        //   }
        });
      
        return errors;
      };
    const errors = validateData(mealDetail);
    if(errors.length > 0){
        const allerror = [];
        errors.forEach((error) => {
            allerror.push(`'${error.item_name}' batch ${error.batch}: ${error.error} \n`);
        });
        alert(allerror);
        return;
    }
    if(newMessages.length > 0){
        if (window.confirm(newMessages.join('\n'))) {
            // User clicked OK, proceed to call the API
            callApi();
        }
    }else{
       
        callApi();
    }
  };
// Kgs planned to 2 decimals. round2 clears the float noise a plain subtraction leaves behind
// (395 - 300.1 is -94.89999999999998 in JavaScript), and show2 prints the fixed 2 places the
// summary rows are read in, so -94.9 reads as -94.90.
const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;
const show2 = (n) => (isFinite(parseFloat(n)) ? round2(n).toFixed(2) : n);

// Truncates typing to 2 decimals. step="0.01" on the input does not do this on its own:
// browsers only validate step on submit, so a third decimal typed into the box goes straight
// through. Truncated rather than rounded -- a half-typed number should not jump a digit.
const twoDecimals = (v) => {
    const s = String(v);
    const dot = s.indexOf(".");
    return dot === -1 ? s : s.slice(0, dot + 3);
};

// A batch with a blank or zero Batch Qty is not a plan, it is an empty row. Saving one creates
// a blank batch that then turns up on the Kit Requisition and Production Support
// screens, so these rows are sent to be deleted instead of written.
const hasBatchQty = (row) => parseFloat(row.planned_batch_raw_qty) > 0;

async function callApi() {
    const toSave = mealDetail.filter(hasBatchQty);
    const toDrop = mealDetail.filter((row) => !hasBatchQty(row));

    const combineData = {
        formData: toSave,
        date: date,
        session: session,
        removeMealDetail: [...removeMealDetail, ...toDrop]
    };
    try {
        await axios.post(`${baseUrl}/production_planning/all-batch`, combineData);
        toast.success("Data successfully saved!");
        // Drop the blank batches from the table now that the server has deleted them. Batch 1
        // stays either way -- it is the row the screen always offers for the item.
        setMealDetail(mealDetail.filter((row) => hasBatchQty(row) || row.batch == 1));
    } catch (error) {
        toast.error("Failed to submit the form.");
        console.log(error);
    }
}



const handleTableInputChange = (index, event) => {
    const values = [...mealDetail];
    const { name, value } = event.target;
    values[index][name] = name === "planned_batch_raw_qty" ? twoDecimals(value) : value;
    setMealDetail(values);
    updateSummedQuantities(values, mealSummary);
};

const updateSummedQuantities = (data, summary) => {
    const totals = data.reduce((acc, item) => {
        const existingItem = acc.find(i => i.eng_name === item.eng_name);
        if (existingItem) {
            existingItem.total_planned_batch_raw_qty += parseFloat(item.planned_batch_raw_qty) || 0;
        } else {
            acc.push({
                eng_name: item.eng_name,
                total_planned_batch_raw_qty: parseFloat(item.planned_batch_raw_qty) || 0
            });
        }
        return acc;
    }, []);

    const updatedSecondArray = summary.map((item, index) => {
        const total_planned_batch_raw_qty = totals[index] ? totals[index].total_planned_batch_raw_qty : item.total_planned_batch_raw_qty;
        const total_planned_raw_qty = parseFloat(item.total_planned_raw_qty);
        const pending_planned_qty = round2(total_planned_batch_raw_qty - total_planned_raw_qty)
        return {
            ...item,
            total_planned_batch_raw_qty : round2(total_planned_batch_raw_qty),
            pending_planned_qty: pending_planned_qty
        };
    });
    // console.log(updatedSecondArray);
    setMealSummary(updatedSecondArray)
};

const handleTableSelectChange = (index, selectedOption, name) => {
    const values = [...mealDetail];
    values[index][name.name] = selectedOption;
    setMealDetail(values);
};
// A batch may only be added once the one before it has a Batch Qty entered -- batch 2 needs
// batch 1 filled in, batch 3 needs batch 2, and so on. Without this the screen happily stacks
// up any number of batches with nothing planned against them.
const canAddRow = (menuItemId) => {
    const batches = mealDetail.filter((row) => row.menu_item_id == menuItemId);
    return parseFloat(batches[batches.length - 1]?.planned_batch_raw_qty) > 0;
};

const handleAddRow = (index) => {
    if (!canAddRow(mealDetail[index].menu_item_id)) {
        toast.error("Please enter Batch Qty for the last batch before adding another");
        return;
    }

    const currentBatch = mealDetail.filter((item) => item.menu_item_id == mealDetail[index].menu_item_id).length ?? 0;

    const currentMenuItemId = mealDetail[index].menu_item_id;

    // Find the index of the last occurrence of currentMenuItemId
    let lastIndex = mealDetail.length - 1;
    for (let i = lastIndex; i >= 0; i--) {
        if (mealDetail[i].menu_item_id === currentMenuItemId) {
            lastIndex = i;
            break;
        }
    }


    const newRow = {
        batch :currentBatch + 1,
        menu_item_id:  mealDetail[index].menu_item_id,
        item_name: mealDetail[index].item_name,
        eng_name:  mealDetail[index].eng_name,
        planned_batch_raw_qty: 0,
        vessel_id: { label: "No Vessel", value: 210 },
        start_time: "",
        end_time:"",
        remarks : ""
    };
    const updatedMealDetail = [...mealDetail];
    
    // Insert the new row at the next index after the current index
    updatedMealDetail.splice(lastIndex + 1, 0, newRow);
    
    // Update the state with the updated array
    setMealDetail(updatedMealDetail);
    // setMealDetail([...mealDetail, newRow]);
};

const handleRemoveRow = (index) => {
    const updatedMealDetail = mealDetail.filter((_, i) => i !== index);
    
    // Update the state with the new array
    setMealDetail(updatedMealDetail);
    setRemoveMealDetail([...removeMealDetail, mealDetail.filter((_, i) => i == index)[0]]);
}

const handelRemarks = (e) => {
    e.preventDefault();
    const updatedArray = mealDetail.map(obj => ({
      ...obj,
      remarks: e.target.value
    }));
    
    setMealDetail(updatedArray);
  }

  return (
    <div className="">
        {loading && <Loader/>}
      <div className="flex justify-between items-center py-4 px-6">
        <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">
        Production Planning
        </h1>
        <Toaster position="top-center" reverseOrder={false} />
        
      </div>
      <div className="relative  shadow-md sm:rounded-lg">
        <DateSessionFilter handleFilterChange={handelFilterChange} />
        {mealList.length > 0 && <table className="border-collapse w-full mb-4">
            <thead>
                <tr  className="bg-gray-100">
                    <td className="border px-4 py-2 font-bold">Menu Item</td>
                    {mealList.map((item, index) => (
                        <td key={index} className="border px-4 py-2"><ItemNameStacked item={item} /></td>
                    ))}
                </tr>
                <tr >
                    <td className="border px-4 py-2 font-bold">Planned RM (kgs)</td>
                    {mealSummary.map((item, index) => (
                        <td key={index} className="border px-4 py-2">{item.total_planned_raw_qty}</td>
                    ))}
                </tr>
                <tr className="">
                    <td className="border px-4 py-2 font-bold">Batch RM (kgs)</td>
                    {mealSummary.map((item, index) => (
                        <td key={index} className="border px-4 py-2">{item.total_planned_batch_raw_qty ?? 0}</td>
                    ))}
                </tr>
                <tr>
                    <td className="border px-4 py-2 font-bold">Pending RM (kgs)</td>
                    {mealSummary.map((item, index) => (
                        <td key={index} className={`${item.pending_planned_qty < 0 ? "bg-red-500" : (item.pending_planned_qty == 0 ? "" : "bg-blue-400")} "border px-4 py-2"`}>{show2(item.pending_planned_qty ?? 0)}</td>
                    ))}
                </tr>
            </thead>
        </table>}
        {mealList.length > 0 &&<table className="table-auto border-collapse w-full">
            <thead>
                <tr className="bg-gray-200">
                    <th className="border px-4 py-2">Menu Item</th>
                    <th className="border px-4 py-2">Batch</th>
                    <th className="border px-4 py-2">Batch Qty</th>
                    <th className="border px-4 py-2">Vessel Name</th>
                    <th className="border px-4 py-2">Start Time</th>
                    <th className="border px-4 py-2">End Time</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
            {mealDetail.length > 0 && mealDetail.map((item, index) => (
                        <tr key={index}>
                            <td className="border px-4 py-2"><ItemNameStacked item={item} /></td>
                            <td className="border px-4 py-2">{item?.batch ?? ''}</td>
                            <td className="border px-4 py-2">
                                <input 
                                    type="number"
                                    step="0.01"
                                    id="planned_batch_raw_qty"
                                    placeholder="Batch Qty"
                                    name="planned_batch_raw_qty"
                                    value={item?.planned_batch_raw_qty || ''}
                                    onChange={(event) => handleTableInputChange(index, event)}
                                    onWheel={(e) => e.target.blur()}
                                    onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                    disabled={item.itemDisable}
                                    className={`p-1 border rounded-md placeholder:text-sm ${item.itemDisable ? "": "bg-orange-50"} w-full`} 
                                />
                            </td>
                            <td className="border px-4 py-2">
                                <Select
                                    {...menuAboveTable}
                                    classNamePrefix="select"
                                    name="vessel_id"
                                    styles={withMenuOnTop({
                                        placeholder: (provided) => ({
                                            ...provided,
                                            fontSize: "0.80rem",
                                        }),
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: item.itemDisable ? "" : "#FFFAF0",
                                            fontSize: "16px",
                                        }),
                                    })}
                                    value={item?.vessel_id ?? ''}
                                    onChange={(selectedOption, name) => handleTableSelectChange(index, selectedOption, name)}
                                    placeholder="Vessel Name"
                                    options={vesselList.map((vessel) => ({
                                        value: vessel.id,
                                        label: vessel.name,
                                    }))}
                                    isDisabled={item.itemDisable}
                                    filterOption={(option, inputValue) => {
                                        return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                                    }}
                                />
                            </td>
                            <td className="border px-4 py-2">
                                <Select
                                    {...menuAboveTable}
                                    classNamePrefix="select"
                                    name="start_time"
                                    styles={withMenuOnTop({
                                        placeholder: (provided) => ({
                                            ...provided,
                                            fontSize: "0.80rem",
                                        }),
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: item.itemDisable ? "" : "#FFFAF0",
                                            fontSize: '16px',
                                        }),
                                    })}
                                    value={item?.start_time ?? ''}
                                    onChange={(selectedOption, name) => handleTableSelectChange(index, selectedOption, name)}
                                    placeholder="Start Time"
                                    isDisabled={item.itemDisable}
                                    className="placeholder:text-sm ms-2 w-full"
                                    options={timeList.map((timeSlot) => ({
                                        value: timeSlot.value,
                                        label: timeSlot.label,
                                    }))}
                                    filterOption={(option, inputValue) => {
                                        return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                                    }}
                                />
                            </td>
                            <td className="border px-4 py-2">
                                <Select
                                    {...menuAboveTable}
                                    classNamePrefix="select"
                                    name="end_time"
                                    styles={withMenuOnTop({
                                        placeholder: (provided) => ({
                                            ...provided,
                                            fontSize: "0.80rem",
                                        }),
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: item.itemDisable ? "" : "#FFFAF0",
                                            fontSize: '16px',
                                        }),
                                    })}
                                    value={item?.end_time ?? ''}
                                    onChange={(selectedOption, name) => handleTableSelectChange(index, selectedOption, name)}
                                    placeholder="End Time"
                                    className="placeholder:text-sm ms-2 w-full"
                                    options={timeList.map((timeSlot) => ({
                                        value: timeSlot.value,
                                        label: timeSlot.label,
                                    }))}
                                    isDisabled={item.itemDisable}
                                    filterOption={(option, inputValue) => {
                                        return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                                    }}
                                />
                            </td>
                            <td className="border px-4 py-2">
                                 
                            {item?.batch == 1 && (
                                // title sits on the wrapper: a disabled button fires no mouse
                                // events, so a tooltip on the button itself never shows.
                                <span title={canAddRow(item.menu_item_id) ? "" : "Enter Batch Qty for the last batch before adding another"}>
                                    <button
                                        onClick={() => handleAddRow(index)}
                                        disabled={!canAddRow(item.menu_item_id)}
                                        className={`p-1 text-white rounded ${canAddRow(item.menu_item_id) ? "bg-blue-500" : "bg-blue-300 cursor-not-allowed"}`}>
                                        Add Row
                                    </button>
                                </span>
                            )}
                                {item?.batch > 1 && <button 
                                disabled={item.removeRow}
                                    onClick={() => handleRemoveRow(index)} 
                                    className="p-1 bg-red-500 text-white rounded">
                                    Remove
                                </button>}
                            </td>
                           
                        </tr>
                    ))}
                
            </tbody>
        </table>}
        <div className="w-full md:w-auto p-5">
    {/* The field was md:w-auto, i.e. the browser's default ~20-character input, too cramped
        for a free-text remark. Widened on desktop; still full width on a phone. */}
    <input
      type="text"
     
      id="remarks"
      name="remarks"
      placeholder="Remarks"
      onChange={(e) => handelRemarks(e)}
      value={mealDetail?.[0]?.remarks ?? ""} 
      className="w-full md:w-96 px-2 py-1 border rounded-md bg-orange-50"
    />
  </div>
        {/* The button used to sit flush in the corner of the rounded, shadowed container and
            got clipped. Padding matches the Remarks block above so the two line up. */}
        {mealList.length > 0 &&<div className="px-5 pb-5">
    <button 
        onClick={(e) => handleSave(e)} 
        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 focus:outline-none focus:bg-blue-600"
    >
        Save
    </button>
</div>}

      </div>
    </div>
  );
}

export default ProductionPlanningList;
